// @ts-strict-ignore
import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Playlist } from 'api';

import getImageFromSet from 'lib/get-image-from-set';

import Grid from 'components/grid';
import Col from 'components/grid/col';
import PlaylistCard from 'components/playlist-card';
import { Link } from 'components/router';
import SkipLink from 'components/skip-link';
import { Heading, Text } from 'components/typography';

type TopicPlaylistsProps = {
  name: string;
  playlists: Playlist[];
  skipLink: string;
  totalCount: number;
  slug: string;
};

function TopicPlaylists({
  name,
  playlists,
  skipLink,
  totalCount,
  slug
}: TopicPlaylistsProps): React.ReactNode {
  return (
    <section id="playlists">
      {skipLink && (
        <SkipLink to={skipLink}>
          <FormattedMessage defaultMessage="Skip playlists" />
        </SkipLink>
      )}
      <Heading size="l" className="mb-8">
        <FormattedMessage
          defaultMessage="Video playlists about {topicName}"
          values={{ topicName: name }}
        />
      </Heading>
      <Grid eightColGrid>
        {playlists.map(playlist => {
          const imageUrl = getImageFromSet(playlist?.primaryImageSet, '1x1');

          return (
            <Col sm={2} md={2} lg={2} xl={3} key={playlist.title}>
              <PlaylistCard
                className="mb-8"
                // TODO Switch to relative link when playlist detail page is implemented on Zenith
                href={`https://www.ted.com/playlists/${playlist.id}/${playlist.slug}`}
                // workaround for "crush" method type definition having "number" as a return type
                imageUrl={imageUrl}
                title={playlist.title}
                description={playlist.description}
                author={playlist.author !== 'TED' && playlist.author}
                talksCount={playlist.videos.totalCount}
              />
            </Col>
          );
        })}
      </Grid>
      {totalCount > playlists.length && (
        <Link href={`/playlists?topics[]=${slug}`}>
          <Text
            size="m"
            tagName="span"
            className="font-bold underline transition-colors hover:text-gray-700"
          >
            {/* Playlists page can't be deep linked to a specific topic */}
            <FormattedMessage
              defaultMessage="See all playlists on {topicName}"
              values={{ topicName: name }}
            />
          </Text>
        </Link>
      )}
    </section>
  );
}

export default TopicPlaylists;
